// extracted by mini-css-extract-plugin
module.exports = {"detail":"index_detail_3Doca","text":"index_text_2smrx","textHidden":"index_textHidden_1f6qk","contentBox":"index_contentBox_3MSYj","boxTitle":"index_boxTitle_2um-Y"};